import draco from '../assets/fonts/Draco.otf'
import hauser from '../assets/fonts/HauserBoldItalic.otf'
import helvetica from '../assets/fonts/HelveticaNeueLTStd-XBlkCnO.otf'
import padaloma from '../assets/fonts/Padaloma_i.ttf'

const fonts = {
  draco,
  hauser,
  helvetica,
  padaloma,
};

export { fonts };
